import TableIcon from '@assets/icons/table.svg?react';
import { ComponentProps, FC } from 'react';
import { BaseModal } from '../BaseModal';
import { ModalPattern } from '../common';
import { ConfirmationModalFooter } from './ConfirmationModalFooter';
import { cn } from '@/lib/utils';

type ConfirmationModalProps = ComponentProps<typeof BaseModal> &
  Omit<ComponentProps<typeof ConfirmationModalFooter>, 'onCancel'> & {
    icon?: React.ReactNode;
    className?: string;
  };

export const ConfirmationModal: FC<ConfirmationModalProps> = ({ children, onClose, classNames, isDismissable, icon, className, ...footerProps }) => {
  const Icon = icon ? icon : <TableIcon className='size-12 text-brand-600' />;

  return (
    <BaseModal onClose={onClose} classNames={{ ...classNames, content: cn(classNames?.content, className) }} isDismissable={isDismissable}>
      <ModalPattern />
      <div className='flex flex-col gap-4'>
        {Icon}
        {children}
      </div>
      <div className='flex flex-col gap-4'>
        <ConfirmationModalFooter onCancel={onClose} {...footerProps} />
      </div>
    </BaseModal>
  );
};
